import React, { useState, useEffect } from "react";
import { auth } from "../firebase";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import Image from "../assets/image.png";
import Logo from "../assets/logo.png";
import GoogleSvg from "../assets/icons8-google.svg";
import { FaEye, FaEyeSlash } from "react-icons/fa6";

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      setLoading(true);
      await signInWithPopup(auth, provider);
      toast.success("Successfully logged in with Google!");
      navigate("/dashboard");
    } catch (err) {
      toast.error("Google login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Please enter both email and password.");
      return;
    }
    try {
      setLoading(true);
      await signInWithEmailAndPassword(auth, email, password);
      toast.success("Login successful!");
      navigate("/dashboard");
    } catch (err) {
      toast.error("Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    

<div className="login-main">
<div className="login-left">
  <img src={Image} alt="Background" />
</div>
<div className="login-right">
  <div className="login-right-container">
    <div className="login-logo">
      <a href="/"><img src={Logo} alt="Logo" /></a>
    </div>
    <div className="login-center">
      <h2 className="login-text">Welcome to Bee's Care!</h2>
      <p>Online Training Program</p>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <div className="pass-input-div">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {showPassword ? (
            <FaEyeSlash onClick={() => setShowPassword(!showPassword)} />
          ) : (
            <FaEye onClick={() => setShowPassword(!showPassword)} />
          )}
        </div>
        <div className="login-center-options">
          <div className="remember-div">
            <input type="checkbox" id="remember-checkbox" />
            <label htmlFor="remember-checkbox">
              Remember me
            </label>
          </div>
          <a href="/forgot-password" className="forgot-pass-link">
            Forgot password?
          </a>
        </div>
        <div className="login-center-buttons">
          <button type="submit" disabled={loading}>
            {loading ? "Logging in..." : "Log In"}
          </button>
          {/* <button
            type="button"
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            <img src={GoogleSvg} alt="Google Icon" />
            Log In with Google
          </button> */}
        </div>
      </form>
    </div>
    <p className="login-bottom-p">
      Don't have an account? <a href="/SignUp">Sign Up</a>
    </p>
  </div>
</div>
<ToastContainer position="top-right" autoClose={5000} hideProgressBar />
</div>

  );
};

export default Login;

